module.exports = __webpack_public_path__ + "img/b6.8f497803.png";